import type { StoreApi, UseBoundStore } from "zustand";

import type {
  AsyncStatusState,
  AsyncStatusStore,
  StoreSelectors,
} from "../../zustand/index.ts";
import { createAsyncStatusStore } from "../../zustand/index.ts";

interface SigninOnReturnStoreResult {
  readonly signinOnReturnSelectors: StoreSelectors<AsyncStatusState>;
  readonly signinOnReturnStore: AsyncStatusStore;
  readonly useSigninOnReturnStore: UseBoundStore<StoreApi<AsyncStatusStore>>;
}

export function createSigninOnReturnStore(): SigninOnReturnStoreResult {
  const { asyncStatusSelectors, asyncStatusStore, useAsyncStatusStore } =
    createAsyncStatusStore();

  return {
    signinOnReturnSelectors: asyncStatusSelectors,
    signinOnReturnStore: asyncStatusStore,
    useSigninOnReturnStore: useAsyncStatusStore,
  };
}
